<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<h3>Modules</h3>

<div class="header d-flex flex-row gap-3">
  <button
    mat-raised-button
    color="primary"
    (click)="showModuleList = !showModuleList"
    [disabled]="!canEdit"
    >
    @if (!(showModuleList$ | async)) {
      Add Module
    } @else {
      Close
    }
  </button>
</div>

@if (showModuleList$ | async) {
  <cas-module-list
    [modules]="modules$ | async"
    [isEditing]="true"
    (getModule)="getModuleFn($event.id, $event.name)"
  ></cas-module-list>
}

@if (!showModuleList) {
  <div class="d-flex flex-row flex-wrap gap-3">
    @for (designModule of designModules$ | async; track trackByFn($index, designModule)) {
      <div
        class="module"
        >
        <cas-design-module
          [designModule]="designModule"
          [module]="moduleQuery.selectByModuleId(designModule.moduleId) | async"
          [canEdit]="canEdit"
        ></cas-design-module>
      </div>
    }
  </div>
}
